var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pagination" }, [
    _c("ul", { staticClass: "pagination u-list-inline" }, [
      _vm.totalPages > 1
        ? _c(
            "li",
            { staticClass: "pagination__item pagination__item--prev" },
            [
              _c("base-button", {
                attrs: {
                  label: "Previous Page",
                  icon: "chevron-left",
                  "icon-size": "16px",
                  disabled: _vm.currentPage === 1
                },
                on: { click: _vm.previousPage }
              })
            ],
            1
          )
        : _vm._e(),
      _c("span", [
        _vm._v(
          "Page " +
            _vm._s(_vm.currentPage) +
            " out of " +
            _vm._s(_vm.totalPages)
        )
      ]),
      _vm.totalPages > 1
        ? _c(
            "li",
            { staticClass: "pagination__item pagination__item--next" },
            [
              _c("base-button", {
                attrs: {
                  label: "Next Page",
                  icon: "chevron-right",
                  "icon-size": "16px",
                  disabled: _vm.currentPage === _vm.totalPages
                },
                on: { click: _vm.nextPage }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }